import styled from "styled-components";

export const StyledSecondary = styled.span`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .description {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: calc(100% - 75px);
  }
  .created-date {
    width: 65px;
    font-size: 10px;
    text-align: right;
  }
`;
